import isEqual from 'lodash/isEqual';

export const isParameterNumerical = parameter =>
  !!parameter && parameter.type === 'numerical';

export const isParameterCategorical = parameter =>
  !!parameter && parameter.type === 'categorical';

export const areParametersTheSame = (oldParameter, newParameter) => {
  if (!oldParameter || !newParameter) {
    return false;
  }

  const sameName = oldParameter.name === newParameter.name;
  const sameType = oldParameter.type === newParameter.type;

  const sameValues = isEqual(
    oldParameter.values.sort(),
    newParameter.values.sort()
  );

  return sameName && sameType && sameValues;
};
